<div class="plt-shell" [class.plt-shell--sidebar-expanded]="!isCollapsed">

  <!-- ── FIXED TOP BAR ─────────────────────────────────────────── -->
  <div class="plt-topbar">

    <!-- Left: logo -->
    <button class="plt-topbar-left"
            type="button"
            (click)="toggleSidebar()"
            [attr.aria-label]="isCollapsed ? 'Open sidebar' : 'Close sidebar'">
      <img *ngIf="hasClientLogo && clientLogo" [src]="clientLogo" alt="Logo" class="plt-logo">
      <img *ngIf="!hasClientLogo" [src]="logo" alt="Logo" class="plt-logo">
      <span class="plt-brand-name">SPRICED</span>
    </button>

    <!-- Dashboard title, when the page opts into showing it inline here
         instead of on-screen (dashboardNamePosition: "top" in its config). -->
    <span *ngIf="dashboardTitlePosition === 'top' && dashboardTitle"
          class="plt-dashboard-title"
          [style.font-size]="dashboardTitleFontSize || null">
      {{ dashboardTitle }}
    </span>

    <!-- Centre: topbar tabs from config (position: "topbar") -->
    <nav class="plt-tabs">
      <a *ngFor="let item of topbarItems"
         class="plt-tab"
         [routerLink]="item.external ? null : item.path"
         routerLinkActive="active"
         (click)="onMenuItemClick(item, $event)">
        {{ item.name }}
      </a>
    </nav>

    <!-- Right: greeting + action icons + avatar -->
    <div class="plt-topbar-right">
      <span class="plt-greeting">Hi, {{ username }}</span>

      <span class="plt-divider"></span>

      <button class="plt-icon-btn" (click)="goToHome()" matTooltip="Home" matTooltipPosition="below">
        <mat-icon>home</mat-icon>
      </button>

      <button class="plt-icon-btn" (click)="goToHelp()" matTooltip="Help" matTooltipPosition="below">
        <mat-icon>help_outline</mat-icon>
      </button>

      <div class="plt-profile-wrapper" (click)="$event.stopPropagation()">
        <button class="plt-icon-btn plt-icon-btn--avatar" (click)="toggleProfileMenu($event)" matTooltip="Profile" matTooltipPosition="below">
          <mat-icon>account_circle</mat-icon>
        </button>
        <div class="plt-profile-dropdown" *ngIf="showProfileMenu">
          <button class="plt-profile-item" (click)="logout()">
            <mat-icon>power_settings_new</mat-icon>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ── BODY: sidebar + router content ────────────────────────── -->
  <div class="plt-body">

    <!-- SIDEBAR -->
    <div class="plt-sidebar" [class.plt-sidebar--expanded]="!isCollapsed">

      <!-- Sidebar items from config (position: "sidebar") -->
      <nav class="plt-nav">
        <ng-container *ngFor="let item of sidebarItems">

          <!-- Leaf item -->
          <a *ngIf="!hasChildren(item)"
             class="plt-nav-item"
             [routerLink]="item.external ? null : item.path"
             [class.plt-nav-item--active]="isSidebarItemSelected(item)"
             (click)="selectSidebarItem(item); onMenuItemClick(item, $event)"
             [matTooltip]="isCollapsed ? item.name : ''"
             matTooltipPosition="right">
            <span *ngIf="item.name === 'Data Explorer'; else sidebarMatIcon" class="plt-nav-icon plt-nav-icon--data-explorer" aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
            </span>
            <ng-template #sidebarMatIcon>
              <mat-icon class="plt-nav-icon">{{ item.icon }}</mat-icon>
            </ng-template>
            <span class="plt-nav-label">{{ item.name }}</span>
          </a>

          <!-- Parent item with children -->
          <div *ngIf="hasChildren(item)">
            <button class="plt-nav-item"
                    [class.plt-nav-item--active]="isSidebarItemSelected(item)"
                    (click)="selectSidebarItem(item); toggleSubmenu(item.name, $event)"
                    [matTooltip]="isCollapsed ? item.name : ''"
                    matTooltipPosition="right">
              <span *ngIf="item.name === 'Data Explorer'; else sidebarParentMatIcon" class="plt-nav-icon plt-nav-icon--data-explorer" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </span>
              <ng-template #sidebarParentMatIcon>
                <mat-icon class="plt-nav-icon">{{ item.icon }}</mat-icon>
              </ng-template>
              <span class="plt-nav-label">{{ item.name }}</span>
              <mat-icon *ngIf="!isCollapsed" class="plt-nav-chevron">
                {{ isMenuExpanded(item.name) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
            <div *ngIf="isMenuExpanded(item.name) && !isCollapsed" class="plt-nav-children">
              <a *ngFor="let child of item.children"
                 class="plt-nav-item plt-nav-item--child"
                 [routerLink]="child.path"
                 [class.plt-nav-item--active]="isSidebarItemSelected(child)"
                 (click)="selectSidebarItem(child)">
                <mat-icon class="plt-nav-icon">{{ child.icon }}</mat-icon>
                <span class="plt-nav-label">{{ child.name }}</span>
              </a>
            </div>
          </div>

        </ng-container>
      </nav>

    </div>

    <!-- PAGE CONTENT -->
    <div class="plt-content">
      <router-outlet></router-outlet>
    </div>

  </div>

</div>
